import { createContext, useContext, useEffect, useState } from "react";
import { getConfig } from "@/lib/api";

const ConfigContext = createContext(null);
const CONFIG_CACHE_KEY = "flip_public_config";
const CONFIG_TTL_MS = 5 * 60 * 1000;

/** Used when /api/config fails — experimental surfaces stay off. */
export const FALLBACK_CONFIG = Object.freeze({
  payment_mode: "demo",
  supported_payment_assets: ["ETH", "SOL", "BNB", "USDC", "USDT", "BTC", "DOGE", "TRX"],
  supported_payment_chains: [
    "ethereum", "base", "arbitrum", "optimism", "bnb", "polygon",
    "avalanche", "solana", "hyperliquid", "robinhood", "bitcoin", "dogecoin", "tron",
  ],
  solana_ecosystem: Object.freeze({ enabled: false, ingest_enabled: false, ecosystem_path: null }),
  base_ecosystem: Object.freeze({ enabled: false, ingest_enabled: false, ecosystem_path: null }),
  robinhood_ecosystem: Object.freeze({ enabled: false, ingest_enabled: false, ecosystem_path: null }),
});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let cached = null;
    try {
      const stored = JSON.parse(sessionStorage.getItem(CONFIG_CACHE_KEY) || "null");
      if (stored?.config && Date.now() - stored.savedAt < CONFIG_TTL_MS) cached = stored.config;
    } catch (e) {}

    if (cached) {
      setConfig(cached);
      return;
    }

    getConfig().then((nextConfig) => {
      setConfig(nextConfig);
      try { sessionStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify({ savedAt: Date.now(), config: nextConfig })); } catch (e) {}
    }).catch(() => setConfig(FALLBACK_CONFIG));
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
